module.exports = __webpack_public_path__ + "static/media/architecture-explanation.7fa60bbc.md";